import { LayoutAdminTable } from 'app/components/templates/LayoutAdminTable';
import { Stack, Typography } from '@mui/material';
import React from 'react';
import { DataTable } from 'app/components/elements/TableCustom';
import { useDispatch } from './hooks';
import { Helmet } from 'react-helmet-async';
import { DialogConfirm } from 'app/components/elements/DialogConfirm';
import MultiSelectAutocomplete from 'app/components/elements/MultiSelectAutocomplete';
import { ButtonCustom } from '../../../components/elements/ButtonCustom';
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import dayjs from 'dayjs';
import { StatusFiles, StatusRedemptions } from 'const/option';
import { capitalizeFirstLetter } from 'const/common';
import { useNavigate } from 'react-router-dom';

export const DispatchPage = () => {
  const {
    rows,
    totalRows,
    page,
    optionsSelected,
    onChangePage,
    handleClickRow,
    showModal,
    setOptionsSelected,
    optionsUser,
    onCloseModal,
    handleSaveModal,
    searchText,
    handelSearch
  } = useDispatch();

  const navigate = useNavigate();

  const HEADER_FILE: GridColDef[] = [
    {
      field: 'createdAt',
      headerName: 'Created At',
      width: 160,
      renderCell: (params: GridRenderCellParams) => {
        const date = new Date(params.row.createdAt);
        return (
          <Stack
            style={{
              flexDirection: 'row',
              alignItems: 'center',
              height: '100%'
            }}
            gap={1}>
            <Typography
              style={{
                color: '#22374A',
                fontSize: '14px'
              }}>
              {dayjs(date).format('YYYY-MM-DD HH:mm')}
            </Typography>
          </Stack>
        );
      }
    },
    {
      field: 'status',
      headerName: 'Status',
      width: 180,
      renderCell: (params: GridRenderCellParams) => {
        const statusFile = params?.row?.fileStatusTransition?.status;
        const statusOpen = params?.value;
        let findStatus;
        if (statusFile === 'OPENED') {
          findStatus = StatusFiles.find((item) => item.value === statusOpen);
        } else {
          findStatus = StatusRedemptions.find((item) => item.value === statusFile);
        }
        return (
          <Stack
            style={{
              justifyContent: 'flex-start',
              alignItems: 'center',
              height: '100%',
              flexDirection: 'row',
              gap: 10
            }}>
            <Stack
              style={{
                background: findStatus?.color || '#9747FF',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '0px 10px',
                height: '20px',
                borderRadius: '5px'
              }}>
              <Typography
                style={{
                  color: '#fff',
                  fontSize: '10px',
                  fontWeight: 600
                }}>
                {capitalizeFirstLetter(findStatus?.value.replace('_', ' ') || 'New')}
              </Typography>
            </Stack>
            {params.row.isFileReopen && (
              <Stack
                style={{
                  background: params.row.isFileReopen ? '#FF4773' : 'blue',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: '0px 10px',
                  height: '20px',
                  borderRadius: '5px'
                }}>
                <Typography
                  style={{
                    color: '#fff',
                    fontSize: '10px',
                    fontWeight: 600
                  }}>
                  Reopened
                </Typography>
              </Stack>
            )}
          </Stack>
        );
      }
    },
    { field: 'firstName', headerName: 'First Name', width: 160 },
    { field: 'lastName', headerName: 'Last Name', width: 160 },
    { field: 'year', headerName: 'Year', width: 100 },
    { field: 'make', headerName: 'Make', width: 100 },
    { field: 'model', headerName: 'Model', width: 100 },
    { field: 'vin', headerName: 'VIN', width: 100 },
    {
      field: 'clientOption',
      headerName: 'Client',
      width: 100,
      renderCell: (params: GridRenderCellParams) => {
        const value = params?.value?.value;
        return (
          <Stack
            style={{
              flexDirection: 'row',
              alignItems: 'center',
              height: '100%'
            }}
            gap={1}>
            <Typography
              style={{
                color: '#22374A',
                fontSize: '14px',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                width: '100%'
              }}>
              {value}
            </Typography>
          </Stack>
        );
      }
    },
    { field: 'plate', headerName: 'Plate', width: 100 },
    { field: 'fileNumber', headerName: 'File Number', width: 160 },
    { field: 'quickNote', headerName: 'Quick Note', width: 160 },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 300,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <Stack
            style={{
              flexDirection: 'row',
              alignItems: 'center',
              height: '100%',
              width: '100%'
            }}
            gap={1}>
            <ButtonCustom
              onClick={(event) => {
                event.stopPropagation();
                handleClickRow(params.row.id);
              }}
              style={{ maxWidth: '120px', height: '80%' }}
              label={'Dispatch file'}
            />
          </Stack>
        );
      }
    }
  ];

  return (
    <LayoutAdminTable search={searchText} onSearch={handelSearch} title={'Dispatch'}>
      <Helmet>
        <title>Surrey Bailiffs - Dispatch</title>
      </Helmet>
      <DataTable
        data={rows}
        totalRows={totalRows}
        paginationModel={{
          page: page ? Number(page) - 1 : 1,
          pageSize: 20
        }}
        handleRowClick={(params) => navigate(`/admin/files/${params.row.id}`)}
        loading={false}
        handlePaginationModelChange={(newPaginationModel) =>
          onChangePage(newPaginationModel.page + 1)
        }
        header={HEADER_FILE}
      />
      <DialogConfirm
        width={'650px'}
        isOpen={showModal}
        onSubmit={handleSaveModal}
        onClose={onCloseModal}
        textTitle={'Dispatch File'}>
        <Stack
          width={'550px'}
          minHeight={'120px'}
          mb={2}
          gap={2}
          flexDirection={'row'}
          alignItems={'center'}>
          <MultiSelectAutocomplete
            value={optionsSelected}
            label={'Assign to Bailiff'}
            onChange={(_, value) => {
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              setOptionsSelected(value as any);
            }}
            options={optionsUser}
          />
          <ButtonCustom sx={{ width: 200 }} label={'Save'} onClick={handleSaveModal} fullWidth />
        </Stack>
      </DialogConfirm>
    </LayoutAdminTable>
  );
};
